module.exports = __webpack_public_path__ + "img/mouth.3cca4f0b.svg";